// TKT-233 (Doug): single-tab experience. Signed S3 URLs for downloads are
// generated server-side with Content-Disposition: attachment, so clicking a
// same-tab anchor downloads the file in place without spawning a viewer tab
// (important on iPad, where stray tabs fragment the workflow).
export function triggerSignedUrlDownload(url) {
  const link = document.createElement('a');
  link.href = url;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
